export enum ConsentView {
  Consent = 'consent',
  Terms = 'terms',
  Privacy = 'privacy',
}
